import React, { FC } from 'react';
import { qantasHotels } from 'roo-ui/logos';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { Container, Flex, Link } from 'roo-ui/components';
import { QCOM_LANDING_PAGE_URL } from '../../../lib/config';
import { PhoneMenu } from './PhoneMenu';
import { QffMenu } from './QffMenu';
import { themeGet } from 'styled-system';

const qantasLogoClip = '71px';

export const HeaderPhone: FC = () => {
  return (
    <Container pr={0}>
      <HeaderInner>
        <Flex alignItems="center">
          <Link
            href={QCOM_LANDING_PAGE_URL}
            mr={4}
            p={1}
            data-testid="qh-logo-link"
          >
            <Logo
              src={qantasHotels}
              alt="Qantas"
              role="img"
              aria-label="Qantas Logo"
            />
          </Link>
        </Flex>
        <Flex data-print-style="hidden" data-testid="phone-menus">
          <PhoneMenu />
          <QffMenu />
        </Flex>
      </HeaderInner>
    </Container>
  );
};

const Logo = styled.img`
  display: inline-flex;
  clip-path: inset(0 0 -1px ${qantasLogoClip});
  margin-left: -${qantasLogoClip};
  ${themeGet('mediaQueries.1')} {
    width: ${rem('186px')};
  }
`;

const HeaderInner = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;
